<template>
    <div :class="['gs-box',customerClass]">
        <div class="gs-box-title">
            <div style="display: flex;align-items: center;font-size: 16px;width: 100%;">
                <div style="height: 16px; width:2px;background: #0055FF;margin-right: 10px;" v-if="showTitle&&showIcon && (title || $slots.title)"></div>
                <slot name="title" >
                    {{title}}
                </slot>
            </div>
            <slot name="other-content"></slot>
        </div>
        <div class="gs-box-body">
            <slot name="body"></slot>
        </div>
    </div>
</template>
<script>
    export default{
        props: {
            title: { 
                type: String
            },
            customerClass:{
                type: String
            },
            showIcon:{
                type: Boolean,
                default: true
            },
            showTitle:{
                type: Boolean,
                default: true
            }
        }
    }
</script>
<style>
.gs-box{
    background: #fff;
}
.gs-box+.gs-box{
    margin-top: 15px;
}
.gs-box-title{
    padding: 10px;
    font-weight: bold;
    font-size: 14px;
}
.gs-box-body{
    padding: 0 10px 10px 10px;
}
.gs-box-body>.grid-wrap {
    box-shadow: none;
    padding: 0px;
}
</style>